import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ChangeRxChangePatientRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchChangeRxChangePatient } from '../api/changeRxChangePatient.js';
import { rxKeys } from './keys.js';

export interface ChangeRxChangePatientVariables {
  rxChangeId: number;
  data: ChangeRxChangePatientRequestT;
  pendingParams?: {
    detailed?: Parameters<typeof rxKeys.pendingRxChangesDetailed>[0];
  };
}

export function useChangeRxChangePatientMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rx', 'rxchanges', 'change-patient'],
    mutationFn: async ({ rxChangeId, data }: ChangeRxChangePatientVariables): Promise<unknown> => {
      return await fetchChangeRxChangePatient(rxChangeId, data);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: rxKeys.pendingRxChangesDetailed(variables.pendingParams?.detailed),
      });
    },
  });
}
